import React from 'react';

import classnames from 'classnames';

import { EvIcon } from '@evinced-private/ui-common';

import { AriaHaspopup } from 'src/common/types';
import SelectDropIcon from 'src/resources/icons/SelectDropIcon.svg?raw';

import './NavigationMenuTrigger.scss';

interface NavigationMenuTriggerProps {
	id: string;
	isOpen: boolean;
	disabled: boolean;
	ariaLabel: string;
	labelId?: string;
	displayText: string;
	onClick: () => void;
	onKeyDown: (event: React.KeyboardEvent) => void;
	triggerRef: React.RefObject<HTMLButtonElement>;
	ariaHaspopup?: AriaHaspopup;
	ariaExpanded?: boolean;
	ariaControls?: string;
}

export const NavigationMenuTrigger: React.FC<NavigationMenuTriggerProps> = ({
	id,
	isOpen,
	disabled,
	ariaLabel,
	labelId,
	displayText,
	onClick,
	onKeyDown,
	triggerRef,
	ariaHaspopup = 'true',
	ariaExpanded,
	ariaControls
}) => {
	return (
		<button
			ref={triggerRef}
			id={id}
			type="button"
			className="navigation-menu__trigger"
			aria-haspopup={ariaHaspopup || 'true'}
			aria-expanded={(ariaExpanded ?? isOpen) ? 'true' : 'false'}
			aria-controls={ariaControls}
			aria-labelledby={labelId}
			aria-label={ariaLabel ? `${ariaLabel}, ${displayText}` : `${displayText}, menu button`}
			disabled={disabled}
			onClick={onClick}
			onKeyDown={onKeyDown}
		>
			<span className="navigation-menu__trigger-text">{displayText}</span>
			<span
				className={classnames('navigation-menu__arrow', {
					'navigation-menu__arrow--up': isOpen
				})}
				aria-hidden="true"
			>
				<EvIcon icon={SelectDropIcon} small />
			</span>
		</button>
	);
};
